// Function loadWoolLabSwatchLibrarySearchBlock loads the WoolLabSwatchLibrarySearchBlock class by dynamically importing the js on demand if needed

export function loadWoolLabSwatchLibrarySearchBlock($parentEl, isList = false) {

	return import(/* webpackChunkName: "wg-fabric-swatch-favourites-block-chunk" */ '../widgets/woolLabSwatchLibrarySearchBlock').then(wg => {

		const { WoolLabSwatchLibrarySearchBlock } = wg;

		let $wg = $parentEl.querySelector('[data-wg="WoolLabSwatchLibrarySearchBlock"]');

		if(!$wg) {
			// console.info('WoolLabSwatchLibrarySearchBlock: no widget found');
			return null;
		}

		if (isList) {
			let $wgCol = $parentEl.querySelectorAll('[data-wg="WoolLabSwatchLibrarySearchBlock"]');
			let instances = [];
			$wgCol.forEach(($wg, i) => {
				instances.push( new WoolLabSwatchLibrarySearchBlock($wg) );
			});
			if (instances.length === $wgCol.length) return instances;

		} else {
			return new WoolLabSwatchLibrarySearchBlock($wg);
		}


	}).catch(error => error+'An error occurred while loading the WoolLabSwatchLibrarySearchBlock widget');

}
